export const mapObject = (obj, mapFunction) => {
  return Object.fromEntries(
    Object.entries(obj).map(
      ([k, v], i) => [k, mapFunction(v, k, i)]
    )
  );
};